export const VisibilityType = {
  TABLE: 0,
  LIST: 1,
  LIST_VISIBILITY: 2
}

export const SortOrderType = {
  FromAtoZ: 0,
  FromZtoA: 1,
  MostRecent: 2,
  Older: 3,
}

export const FilterType = {
  STRING: 'string',
  NUMBER: 'number',
  DATE_RANGE: 'date-range',
  CHECKBOX_RANGE: 'checkbox-range',
  RADIO_RANGE: 'radio-range',
  NUMBER_RANGE: 'number-range'
}

export const SortOrderList = [
  {
    label: 'From A to Z',
    value: SortOrderType.FromAtoZ,
    sortColumn: "Name_TR1",
    sortOrder: 0
  },
  {
    label: 'From Z to A',
    value: SortOrderType.FromZtoA,
    sortColumn: "Name_TR1",
    sortOrder: 1
  },
  {
    label: 'Most Recent',
    value: SortOrderType.MostRecent,
    sortColumn: "Id",
    sortOrder: 1
  },
  {
    label: 'Older',
    value: SortOrderType.Older,
    sortColumn: "Id",
    sortOrder: 0
  },
]

export const CategoryManagementSOType = {
  DefineOrderTechSpend: 0,
  DefineOrderStorefront: 1,
}

export const CategoryManagementSOList = [
  {
    label: 'Define order for Tech Spend',
    value: CategoryManagementSOType.DefineOrderTechSpend,
  },
  {
    label: 'Define order for Storefront',
    value: CategoryManagementSOType.DefineOrderStorefront,
  },
]
